var e = {};
export {
  e as __exports
};
//# sourceMappingURL=index.es450.js.map
